<template>
  <div>
    <template v-if="!this.media.every(m => this.cache[m.hash || m.id])">
      Downloading ({{ Object.keys(dl).length }}) files:
      <div v-for="(file, index) in dl" :key="index">
        {{ file.name }} {{ file.progress | percent }}
      </div> 
    </template>
    <template v-else>
      <player-core id="core" :background="'#000'" :hideControls="false" :cache="computedCache" :queue="computedMedia"></player-core>
    </template>
  </div>
</template>

<script>
// /* eslint-disable no-unused-vars */
// /* eslint-disable vue/no-unused-components */
import PlayerCore from '@/components/Player/Core.vue'
import axios from 'axios'

export default {
    components: {
      PlayerCore
    },
    data() {
      return {
        axios: {},
        cancelTokens: {},
        cache: {},
        dl: {},
        errored: {},
        progress: 0,
        test: 0,
      }
    },
    props: {
      media: {
        type: Array,
        required: true
      },
      showControls: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      computedCache() {
        return {
          0: this.cache
        }
      },
      computedMedia() {
        return [
        {
          campaignId: 0,
          media: this.media,
          }
        ]
      }
    },
    mounted() {
      this.idempotent_add()
    },
    methods: {
      idempotent_add() {
        // console.log('idempotent_add')
        for (let media of this.media.filter(m => !m.mimeType.includes('text'))) {
          // cache by file hash so the same file shared across campaigns is only
          // downloaded/held once (fall back to the per-placement id if no hash)
          const key = media.hash || media.id
          if (this.cache[key] || this.axios[key]) {
            // console.log('file', key, 'already cached/downloading')
          }
          else {
            this.$set(this.dl, key, {
              name: media.name,
              progress: 0,
            })
            const CancelToken = axios.CancelToken
            this.cancelTokens[key] = CancelToken.source()
            this.axios[key] = axios.get(media.uri, {
              responseType: 'blob',
              cancelToken: this.cancelTokens[key].token,
              onDownloadProgress: (status) => {
                if (this.dl[key]) this.dl[key].progress = parseInt((status.loaded / status.total) * 100)
              },
            })
              .then((response) => {
                this.cache[key] = response.data
                this.$delete(this.dl, key)
              })
              .catch(function () {
                // console.log(error);
              })
          }
        }
      }
    },
    beforeDestroy() {
      // cancel existing downloads
      Object.values(this.cancelTokens).forEach(req => req.cancel())
    },
    watch: {
      media() {
        this.idempotent_add()
      },
      seekOffset() {
        
      }
    },
}

</script>

<style scoped>
  #core {
    width: 100%;
    height: 100%;
  }
</style>